import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=b083dbc8&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=b083dbc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b083dbc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b083dbc8')) {
      api.createRecord('b083dbc8', component.options)
    } else {
      api.reload('b083dbc8', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=b083dbc8&scoped=true", function () {
      api.rerender('b083dbc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/NotFound.vue"
export default component.exports